exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  background-color: #fff;\n  width: 100%;\n  padding: 30px 40px 50px 40px; }\n\n.copy-rights {\n  color: #B8BAC3;\n  margin: 0;\n  float: left; }\n\n.copy-rights a {\n  color: #B8BAC3; }\n\n.copy-rights a:hover {\n  color: #ff6838; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/footer/footer.component.scss
// module id = ../../../../../src/app/shared/components/footer/footer.component.scss
// module chunks = main